import { render } from "./NotFoundText.vue?vue&type=template&id=6cf4488a&scoped=true"
import script from "./NotFoundText.vue?vue&type=script&lang=js"
export * from "./NotFoundText.vue?vue&type=script&lang=js"

import "./NotFoundText.vue?vue&type=style&index=0&id=6cf4488a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf4488a"]])

export default __exports__